<div class="modal-header align-items-center justify-content-between">
  <h5 class="modal-title" id="modal-basic-title" [ngClass]="'text-' + btnColor">
    {{ title }}
  </h5>
  <button
    type="button"
    class="modal-close close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
    <span class="material-symbols-rounded">close</span>
  </button>
</div>

<div class="modal-body">
  <form class="grid row-gap-2 mb-3" [formGroup]="motivoForm" autocomplete="off">
    <div class="form-group g-col-12">
      <label
        for="ositran-revision-motivo"
        class="col-form-label col-form-label-sm"
        [ngClass]="{ 'u-required': isRequired }"
        >{{ label }}</label
      >
      <textarea
        name="ositran-revision-motivo"
        id="ositran-revision-motivo"
        class="form-control no-resize"
        [ngClass]="{
          'is-invalid':
            motivoForm.get('motivo')?.invalid &&
            motivoForm.get('motivo')?.touched,
        }"
        formControlName="motivo"
        placeholder="Ingresa el motivo"
        cols="30"
        rows="4"
        maxlength="500"
        style="resize: none"
      ></textarea>

      @if (
        motivoForm.get("motivo")?.invalid && motivoForm.get("motivo")?.touched
      ) {
        <span
          class="d-block mt-2"
          errorLabel
          [errors]="motivoForm.get('motivo')?.errors"
        ></span>
      }
      <small class="py-0"> {{ longitudCampo("motivo") }}/500 caracteres </small>
    </div>
  </form>
</div>

<div
  class="modal-footer d-flex justify-content-center align-items-center gap-3"
>
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="activeModal.dismiss()"
  >
    Cancelar
  </button>
  <button
    type="button"
    class="btn text-white"
    [ngClass]="'btn-' + btnColor"
    (click)="observar()"
  >
    {{ btnText }}
  </button>
</div>
